import React from 'react';
import {
  Col,
  Row,
  Container,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane
} from 'reactstrap';
import ConfigRecebimentoContainer from './tab/material/recebimento.container';
import ConfigMapaMacroscopicoContainer from './tab/mapa_macroscopico/mapa-macroscopico.container';
import ConfiguracoesGeraisContainer from './tab/geral/geral.container';
import ConfiguracoesEmailContainer from './tab/email/email.container';
import ConfiguracoesCertificadoContainer from './tab/certificado/certificado.container';
import classnames from 'classnames';
import './configuracao.style.css';
import IntlMessage from '../../../src/helpers/intlMessage';

const ConfiguracaoPage = props => (
  <div>
    <Container fluid className='mv-workspace-container-config'>
      <Row>
        <Col>
          <Row className='mv-config'>
            <Col sm={'auto'}>
              <h2 className='title-citologia'><IntlMessage id = "dashboards.general.settings"/></h2>
            </Col>
          </Row>

          <div
            className='config-container'
            style={{ minHeight: `${props.altura}px` }}
          >
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={classnames({ active: props.activeTab === '1' })}
                  onClick={() => {
                    props.toggle('1');
                  }}
                >
                  <IntlMessage id = "dashboards.examDetail.general"/>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: props.activeTab === '2' })}
                  onClick={() => {
                    props.toggle('2');
                  }}
                >
                  <IntlMessage id = "dashboards.general.sampleReceipt"/>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: props.activeTab === '3' })}
                  onClick={() => {
                    props.toggle('3');
                  }}
                >
                  <IntlMessage id = "dashboards.examDetail.technicalArea"/>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: props.activeTab === '4' })}
                  onClick={() => {
                    props.toggle('4');
                  }}
                >
                  <IntlMessage id = "dashboards.general.email"/>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({ active: props.activeTab === '5' })}
                  onClick={() => {
                    props.toggle('5');
                  }}
                >
                  <IntlMessage id = "dashboards.general.certification"/>
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={props.activeTab}>
              <TabPane tabId='1'>
                {props.activeTab === '1' && (
                  <ConfiguracoesGeraisContainer altura={props.altura - 110} />
                )}
              </TabPane>
              <TabPane tabId='2'>
                {props.activeTab === '2' && (
                  <ConfigRecebimentoContainer altura={props.altura - 190} />
                )}
              </TabPane>
              <TabPane tabId='3'>
                {props.activeTab === '3' && (
                  <ConfigMapaMacroscopicoContainer
                    altura={props.altura - 190}
                  />
                )}
              </TabPane>
              <TabPane tabId='4'>
                {props.activeTab === '4' && (
                  <ConfiguracoesEmailContainer
                    altura={props.altura - 190}
                  />
                )}
              </TabPane>
              <TabPane tabId='5'>
                {props.activeTab === '5' && (
                  <ConfiguracoesCertificadoContainer
                    altura={props.altura - 190}
                  />
                )}
              </TabPane>
            </TabContent>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
);

export default ConfiguracaoPage;



// WEBPACK FOOTER //
// ./src/pages/configuracao/configuracao.page.js